"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_STARTUP_ITEMS = exports.GET_FEATURE_TOGGLES = void 0;
const app_queries_1 = require("./app-queries");
exports.GET_FEATURE_TOGGLES = `
	{
		featureToggles
	}
`;
exports.GET_STARTUP_ITEMS = `
  {
    constants
    productTypes
    groups
    categories
    topics
    industries
    trends
    skills
    locations
    jobRoles
    careerStages
    contentLanguages
    firmMemberships
    sections
    accessRestrictions
    credentials
    topicalSubscriptions
    engagementMenuList
    megamenu
    featureToggles
    popularSites
    ${app_queries_1.getRenewalSeasonInfo}
  }
`;
//# sourceMappingURL=startup-queries.js.map